import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {MatTableDataSource} from "@angular/material/table";
import moment from 'moment';

export interface DistributionsOtherDatesTable {
  field: string;
  value: string;
  isTarget: null | boolean;
}

@Component({
    selector: 'deal-other-disposition-dates-table',
    templateUrl: './other-disposition-dates-table.component.html',
    styleUrls: ['./other-disposition-dates-table.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OtherDispositionDatesTableComponent {
  @Input() dates: any;

  dColumns: string[] = ['field', 'value'];
  dDataSource: MatTableDataSource<DistributionsOtherDatesTable>;

  ngOnInit() {
    let formatted: Array<DistributionsOtherDatesTable> = [];
    for(let i = 0; i < this.dates.length; i++){
      formatted.push({
        field: this.dates[i]['dateType']['name'],
        value: moment
          .utc(this.dates[i]['date'])
          .format('MM/DD/YYYY'),
        isTarget: this.dates[i]['dateClass'] === 'target'
      });
    }

    this.dDataSource = new MatTableDataSource(formatted);
  }
}
